module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-product-2-c86c49372e8bf07650ff1bc5be8b9a36.jpg";